import { gql, useMutation } from '@apollo/client';

import { updateUser } from '../../../actions/entities';
import { User } from '../../../models/User';
import { useAppDispatch } from '../../../store';

const verifyWhatsappNumber = gql`
  mutation verifyWhatsappNumber($whatsappVerificationToken: String!) {
    verifyWhatsappNumber(
      whatsappVerificationToken: $whatsappVerificationToken
    ) {
      id
      isWhatsappVerified
      metadata
    }
  }
`;

type VerifyWhatsappNumberInput = {
  whatsappVerificationToken: string;
};

type VerifyWhatsappNumberResponse = {
  verifyWhatsappNumber: Pick<User, 'id' | 'isWhatsappVerified' | 'metadata'>;
};

export const useVerifyWhatsappNumber = () => {
  const dispatch = useAppDispatch();
  return useMutation<VerifyWhatsappNumberResponse, VerifyWhatsappNumberInput>(
    verifyWhatsappNumber,
    {
      onCompleted: data => {
        dispatch(
          updateUser(data.verifyWhatsappNumber.id, data.verifyWhatsappNumber)
        );
      },
    }
  );
};
